<!-- <button class="btn btn-primary mr-1 mb-1" *ngFor="let category of allConsoleCategories" (click)="changeCategory(category)"> -->
<button class="btn btn-primary mr-1 mb-1" *ngFor="let category of categoriesToCallTicket" (click)="changeCategory(category)">
    <span class="element-text">{{ category.fullName }}</span>
    <span *ngIf="isAvailable(category.id)"><i class="fas fa-check"></i></span>
    <span *ngIf="!isAvailable(category.id)"><i class="fas fa-times"></i></span>
</button>
